import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const Backdrop = styled(motion.div, {
  base: {
    position: 'fixed',
    inset: '0',
    backgroundColor: 'rgba(26, 19, 48, 0.45)',
    zIndex: '110',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '120px',
    paddingX: '20px',
  },
})

const Panel = styled(motion.div, {
  base: {
    width: '100%',
    maxWidth: '520px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 28px 80px -20px rgba(26, 19, 48, 0.32)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
})

const SearchWrapper = styled('div', {
  base: {
    padding: '14px 18px',
    borderBottom: '1px solid',
    borderColor: '#F0EDFA',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
})

const SearchGlyph = styled('span', {
  base: {
    fontSize: '18px',
    lineHeight: '1',
  },
})

const SearchInput = styled('input', {
  base: {
    flex: '1',
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.ink',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    _placeholder: {
      color: '#B8B0CC',
      opacity: '1',
    },
  },
})

const KeyHintRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    flexShrink: '0',
  },
})

const KeyHint = styled('kbd', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    color: 'quickpass.inkSoft',
    backgroundColor: 'quickpass.surfaceCool',
    paddingX: '6px',
    paddingY: '3px',
    borderRadius: 'sm',
    border: '1px solid',
    borderColor: '#E5E0F5',
    minWidth: '20px',
    textAlign: 'center',
  },
})

const ResultsList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: '6px',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    maxHeight: '320px',
    overflowY: 'auto',
  },
})

const ResultRow = styled('li', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    paddingX: '12px',
    paddingY: '10px',
    borderRadius: 'sm',
    cursor: 'pointer',
    transition: 'background-color {durations.fast} {easings.appleStandard}',
  },
  variants: {
    isActive: {
      true: {
        backgroundColor: 'quickpass.surfaceCool',
      },
    },
  },
})

const ResultGlyph = styled('span', {
  base: {
    fontSize: '18px',
    lineHeight: '1',
    flexShrink: '0',
  },
})

const ResultBody = styled('div', {
  base: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: '0',
  },
})

const ResultLabel = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const ResultHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
  },
})

const EmptyState = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    textAlign: 'center',
    padding: '40px 24px',
    fontStyle: 'italic',
  },
})

const FooterRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    borderTop: '1px solid',
    borderColor: '#F0EDFA',
    backgroundColor: 'quickpass.surfaceCool',
  },
})

const FooterHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
})

export {
  Backdrop,
  Panel,
  SearchWrapper,
  SearchGlyph,
  SearchInput,
  KeyHintRow,
  KeyHint,
  ResultsList,
  ResultRow,
  ResultGlyph,
  ResultBody,
  ResultLabel,
  ResultHint,
  EmptyState,
  FooterRow,
  FooterHint,
}
